import type { FeedbackMessages } from './en';

const ja: FeedbackMessages = {
  qualified: {
    title: 'ご協力いただきありがとうございました！',
    text: 'このままブラウザウィンドウを閉じていただいて構いません。\n\n近いうちに再びご参加いただけますことを楽しみにしております。',
  },
  quotaFull: {
    title: '本調査は終了いたしました',
    text: '本調査にご興味をお持ちいただき、ありがとうございます。\n\n誠に申し訳ございませんが、必要な回答数にすでに達しております。\n\n今後の調査でまたお会いできることを楽しみにしております。',
  },
  terminated: {
    title: 'ご意見をお寄せいただきありがとうございました！',
    text: '今後の調査でまたお会いできることを楽しみにしております。それでは、良い一日をお過ごしください。\n\nこのブラウザウィンドウを閉じてください。',
  },
  mismatch: {
    title: 'ご興味をお持ちいただきありがとうございます',
    text: '誠に申し訳ございませんが、今回の調査の対象者には該当しませんでした。\n\nこのページを閉じていただいて構いません。',
  },
  error: {
    title: 'リクエストを処理できませんでした',
    linkProblemDetailed:
      'アクセスされたリンクに問題が発生しています。アドレスバーのリンクが、お送りしたものと一致しているかご確認のうえ、もう一度お試しください。',
    linkProblemGeneric: 'アクセスされたリンクに問題が発生しています。もう一度お試しください。',
    contactPerson:
      '問題が解決しない場合は、リンクをお送りした担当者にこの問題についてお知らせください。',
  },
};

export default ja;
